import { render, staticRenderFns } from "./incidentDate.vue?vue&type=template&id=6c012158&"
import script from "./incidentDate.vue?vue&type=script&lang=js&"
export * from "./incidentDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports